"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AppsProvider = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));

var _spin = _interopRequireDefault(require("antd/lib/spin"));

var _apps = require("./gqls/apps");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var defaultApps = ['memberGroup', 'freeGift', 'freeShipping', 'bulkdiscount', 'groupDiscount', 'productDiscount', 'points', 'newsletters', 'productAuthority', 'productMassUpdate', 'memberGroupCode', 'coupon', 'tagDiscount', 'productNotice', 'returnOrder', 'replacement', 'memberSeePrice', 'wishList', 'ezcat', 'pageDataAnalytics'].reduce(function (result, key) {
  return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, key, {
    id: key,
    storeAppId: null,
    isInstalled: false
  }));
}, {});

var AppsContext = /*#__PURE__*/_react["default"].createContext(defaultApps);

var AppsProvider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children;

  var _useQuery = (0, _client.useQuery)(_apps.getApps),
      data = _useQuery.data;

  var apps = (0, _react.useMemo)(function () {
    var _data$getStoreAppList;

    return ((data === null || data === void 0 ? void 0 : (_data$getStoreAppList = data.getStoreAppList) === null || _data$getStoreAppList === void 0 ? void 0 : _data$getStoreAppList.data) || []).reduce(function (result, app) {
      if (!app) return result;
      var id = app.id,
          appId = app.appId,
          isInstalled = app.isInstalled,
          plugin = app.plugin;
      if (!plugin) return result;
      return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, plugin, {
        id: appId,
        storeAppId: id,
        isInstalled: Boolean(isInstalled)
      }));
    }, defaultApps);
  }, [data]);
  if (!data) return /*#__PURE__*/_react["default"].createElement(_spin["default"], {
    indicator: /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], {
      spin: true
    })
  });
  return /*#__PURE__*/_react["default"].createElement(AppsContext.Provider, {
    value: apps
  }, children);
});

exports.AppsProvider = AppsProvider;
var _default = AppsContext;
exports["default"] = _default;